import React from 'react';
import { TileLayer } from 'react-leaflet';

const Tile = ({ attribution, url }) => (
  <TileLayer attribution={attribution} url={url} />
);

export default Tile;
